import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { TermanService } from 'src/app/services/terman.service';
import { TestService } from 'src/app/services/test.service';
import { TimerService } from 'src/app/services/timer.service';

import Swal from 'sweetalert2'

declare var jQuery:any;


@Component({
  selector: 'app-terman',
  templateUrl: './terman.component.html',
  styles: [
  ]
})
export class TermanComponent implements OnInit {

  public counter=[];
  public serieCompleted = false;
  public showingInstructions = true;
  public questions=[];
  public selectedSerie=1;
  public minutes=0; 
  public seconds=0;
  public selected=[];
  public booleanArray=[];
  public doubleSelection=[];
  public doubleText=[];
  public lastSelected=0;
  public time;
  public started=false;
  public answers=[];
  private acum = 0;
  public testData;
  public photoTaked = false;
  public trigger = false;
  public serieScore={
    "1":0,
    "2":0,
    "3":0,
    "4":0,
    "5":0,
    "6":0,
    "7":0,
    "8":0,
    "9":0,
    "10":0
  }

  public timers={
    1:120,
    2:180,
    3:180,
    4:240,
    5:300,
    6:120,
    7:120,
    8:240,
    9:240,
    10:300,
  }

  public qnts=[];
  public texts;
  public completedQuestions = 0;
  @ViewChild('instructions') instructions: ElementRef;
  
  constructor(private termanService:TermanService, private timerService:TimerService, private testService:TestService, private router: Router) {
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
      },
      err=>console.log(err)
    )
    this.termanService.getQuestions().subscribe(
      resp=>{
        this.questions=resp;
        resp.map(x=>{
          this.doubleSelection.push({
            opcA:false,
            opcB:false,
            opcC:false,
            opcD:false,
            opcE:false
          });
          this.qnts.push(0);
          this.selected.push("");
          this.booleanArray.push(false);
          this.doubleText.push({
            1:"",
            2:""
          })
        })
      },
      err=>{
        console.log(err);
      }
    )
    if(!this.testService.selectedTestData){
      this.router.navigateByUrl('dashboard/requestedTests');
    }
    this.testData = this.testService.selectedTestData;
   }

  ngOnInit(): void {
  }

  reload(){
    location.reload()
  }
  
  ngAfterViewInit(){
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        setTimeout(()=>{
          this.instructions.nativeElement.innerHTML = this.texts.termanInstructions;
        }, 500)
      },
      err=>console.log(err)
    )    

  }

  addCounter(i, serie){
    this.counter[i] = true;
    var serieCounter = this.acum;
    this.questions.map(q=>{
      if(q.serie==serie) serieCounter++;
    })
    this.serieCompleted = true;
    for (let j=this.acum; j<serieCounter; j++){
      
      if (this.counter[j]==false||!this.counter[j]) this.serieCompleted = false;
      if ((i)==(serieCounter-1)) this.acum = serieCounter;
    }
  }

  startCounter(){
      window.scrollTo(0, 0);
      this.showingInstructions=false;
      this.timerService.start();
      this.time = setInterval(()=>{
      this.seconds=this.timerService.getSeconds();
      this.minutes=this.timerService.getMinutes();
      if(this.minutes>=this.timers[this.selectedSerie]/60) {
        this.nextSerie();
        this.showingInstructions=true;
      }
    },1000)
  }

  handleNextSection(){
    this.nextSerie()
    this.showingInstructions=true;
  }

  addQuestionsQuantity(){
    let serieQuestionsQty = 0;
    this.questions.map(q=>{
      if(q.serie==this.selectedSerie) serieQuestionsQty++;
    })
    this.completedQuestions += serieQuestionsQty;
  }

  nextSerie(){
    this.addQuestionsQuantity();
    this.serieCompleted = false;
    this.showingInstructions = false;
    if (this.selectedSerie==1){
      var i=0;
      for (let j of this.selected){
        if(this.questions[i].serie==this.selectedSerie) this.answers.push(this.selected[i])
        var res = this.questions[i][j];
        if (res){
          if (this.serieScore[1]<16) this.serieScore[1]+=res.value;
        }   
        i++;
      }
      clearInterval(this.time);
      this.timerService.stop();
      this.selected.map(x=>x="");
    }

    if (this.selectedSerie==2){
      var i=0;
      for (let j of this.selected){
        if(this.questions[i].serie==this.selectedSerie) this.answers.push(this.selected[i])
        var res = this.questions[i][j];
        if (res){
          if (this.serieScore[2]<22) this.serieScore[2]+=res.value;
        }   
        i++;
      }
      clearInterval(this.time);
      this.timerService.stop();

      this.selected.map(x=>x="");
    }

    if (this.selectedSerie==3){
      var i=0;
      for (let j in this.selected){
        if(this.questions[j].serie==this.selectedSerie) this.answers.push(this.selected[j]);
        if(this.selected[j])
        if(this.questions[j].pair.value.toUpperCase()==this.selected[j].toUpperCase()){
          if (this.serieScore[3]<30) this.serieScore[3]++;
        }
        i++;
      }

      clearInterval(this.time);
      this.timerService.stop();
      this.selected.map(x=>x="");
    }
    
    if (this.selectedSerie==4){

      for (let j in this.questions){
        if(this.questions[j].serie==this.selectedSerie) this.answers.push(this.doubleSelection[j]);

        if(this.questions[j].serie==4&&
           this.questions[j].doubleSelection.opcA.value==this.doubleSelection[j].opcA&&
           this.questions[j].doubleSelection.opcB.value==this.doubleSelection[j].opcB&&
           this.questions[j].doubleSelection.opcC.value==this.doubleSelection[j].opcC&&
           this.questions[j].doubleSelection.opcD.value==this.doubleSelection[j].opcD&&
           this.questions[j].doubleSelection.opcE.value==this.doubleSelection[j].opcE){
            if (this.serieScore[4]<18) this.serieScore[4]++;
        }
      }
      clearInterval(this.time);
      this.timerService.stop();

      this.doubleSelection=[];
      this.selected.map(x=>x="");
    }

    if (this.selectedSerie==5){

      for (let j in this.selected){
        if(this.questions[j].serie==this.selectedSerie) this.answers.push(this.selected[j]);

        if(this.questions[j].numbers.value==this.selected[j]){
          if (this.serieScore[5]<24) this.serieScore[5]++;
        }

      }
      clearInterval(this.time);
      this.timerService.stop();

      this.selected.map(x=>x="");
    }

    if (this.selectedSerie==6){
      for (let j in this.questions){
        if(this.questions[j].serie==this.selectedSerie) this.answers.push(this.booleanArray[j]);

        if(this.questions[j].boolean.value==this.booleanArray[j]&&this.questions[j].serie==6){
          if (this.serieScore[6]<20) this.serieScore[6]++;
        }
        i++;
      }
      this.questions.map(x=>{
          this.doubleSelection.push({
            opcA:false,
            opcB:false,
            opcC:false,
            opcD:false,
            opcE:false
          });
          this.booleanArray.push(false);
        })
      clearInterval(this.time);
      this.timerService.stop();

      this.booleanArray.map(x=>x=false);

    }


    if (this.selectedSerie==7){
      var i=0;
      for (let j in this.selected){
        if(this.questions[j].serie==this.selectedSerie) this.answers.push(this.selected[j]);

      }

      for (let j of this.selected){

        var res = this.questions[i][j];
        if (res){
          if (this.serieScore[7]<20)this.serieScore[7]+=res.value;
        }   
        i++;
      }
      clearInterval(this.time);
      this.timerService.stop();

      this.selected.map(x=>x="");

    }

    if (this.selectedSerie==8){
      for (let j in this.questions){
        if(this.questions[j].serie==this.selectedSerie) this.answers.push(this.booleanArray[j]);

        if(this.questions[j].boolean.value==this.booleanArray[j]&&this.questions[j].serie==8){
          if (this.serieScore[8]<17) this.serieScore[8]++;
        }
        i++;
      }
      clearInterval(this.time);
      this.timerService.stop();

      this.booleanArray.map(x=>x=false);

    }


    if (this.selectedSerie==9){
      var i=0;
      for (let j of this.selected){
        if(this.questions[i].serie==this.selectedSerie) this.answers.push(this.doubleSelection[i]);

        var res = this.questions[i][j];
        if (res){
          if(res.value){
            if (this.serieScore[9]<18) this.serieScore[9]=this.serieScore[9]+res.value;
          }
        }   
        i++;
      }
      clearInterval(this.time);
      this.timerService.stop();

      this.selected.map(x=>x="");

    }

    if (this.selectedSerie==10){
      
      for (let j in this.doubleText){
        if(this.questions[j].serie==this.selectedSerie) this.answers.push(this.doubleText[j]);

        if(this.questions[j].serie==10&&this.questions[j].textNumbers.firstValue==this.doubleText[j][1]&&this.questions[j].textNumbers.secondValue==this.doubleText[j][2]){
          if (this.serieScore[10]<22) this.serieScore[10]++;
        }

      }
      clearInterval(this.time);
      this.timerService.stop();


    }
    this.minutes=0;
    this.seconds=0;
    this.selectedSerie++;

    if(this.selectedSerie>10){
      this.trigger = !this.trigger;
      this.started=false;
      clearInterval(this.time);
      this.timerService.stop();
      if(this.time>=10){
        Swal.fire({
          text:'Has concluido esta evaluación. Agradecemos tu participación',
          icon:'success',
          confirmButtonText:'Salir'
        });
      }else{

        Swal.fire({
          text:'Has concluido esta evaluación. Agradecemos tu participación',
          icon:'success',
          confirmButtonText:'Salir'
        });
      }
      jQuery("#myModal").modal("hide");
      var data={
        score:this.serieScore,
        answers:this.answers,
      }
      this.termanService.createReport(data).subscribe(
        res=>{
      
          var testData = this.testService.selectedTestData;
          testData.isCompleted = true;
          testData.reportId = res._id;
          testData.completeDate = Date.now();
          this.testService.updateTest(testData).subscribe(
            r=>{
       
              this.router.navigateByUrl('dashboard/requestedTests');
            },
            e=>console.log(e)
          );
        },
        err=> console.log(err)
      )
    }

  }

  setLastSelected(last){
    this.lastSelected=last+1;
  }


  startTest(){
    this.testService.testStarted = true;

    if (this.testData.camera){
      setTimeout(() => {
        this.trigger = !this.trigger;
      }, Math.floor(Math.random() * 60000 + 240000));
    }
    this.showingInstructions = true;
    var testData = this.testService.selectedTestData;
    testData.isStarted = true;
    testData.startDate = Date.now();
    this.testService.updateTest(testData).subscribe();
    this.started=true;

  }

  checkQnt(i,event){

    if(event==true){
      this.qnts[i]++;
    }else this.qnts[i]--;
  }


}
